import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const AnimatedTabCard = ({ tabs, data, height }) => {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <div className="flex flex-col h-full bg-white rounded-[5px] border border-gray-150">
      {/* Tab Buttons */}
      <div className="bg-[#3B3B3B] text-white px-4 py-2 flex items-center justify-center rounded-tl-[5px] rounded-tr-[5px] h-10">
        <div className="flex justify-center items-center gap-4">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`text-sm font-semibold px-6 py-2 transition-all duration-300 ${
                tabIndex === index
                  ? "bg-[#3b3b3b] text-white border-b-2 border-white"
                  : "text-gray-300 hover:text-white hover:opacity-90"
              }`}
              onClick={() => setTabIndex(index)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div
        className="relative overflow-hidden flex-grow"
        style={{ height: height - 60 }} // Adjust for the height of the blue bar
      >
        {tabs.map((_, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-transform duration-500 ease-in-out ${
              tabIndex === index
                ? "translate-x-0"
                : tabIndex > index
                ? "-translate-x-full"
                : "translate-x-full"
            }`}
          >
            {index === 0 &&
              (data.risks?.length > 0 ? (
                <div className="p-4 overflow-y-auto">
                  <h1 className="text-lg font-bold text-[#000000]">
                    {data.risks[0]?.risk_title || t("riskDashboard.fallback.noTitle")}
                  </h1>
                  <p className="text-normal">
                    {data.risks[0]?.risk_definition || t("riskDashboard.empty.noDefinition")}
                  </p>
                </div>
              ) : (
                <p className="text-gray-500 p-4">{t("riskDashboard.empty.noRisks")}</p>
              ))}
            {index === 1 &&
              (data.controls?.length > 0 ? (
                <div className="p-4 overflow-y-auto">
                  {data.controls.map((control, idx) => (
                    <div key={idx}>
                      <h1 className="text-lg font-bold text-[#000000] flex items-center">
                        <span className="fa fa-check-circle mr-2"></span>
                        {control.control_type || t("riskDashboard.fallback.noControlType")}
                      </h1>
                      <p className="text-normal">{control.control_details || t("riskDashboard.fallback.noControlDetails")}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500 p-4">{t("riskDashboard.empty.noControls")}</p>
              ))}
            {index === 2 &&
              (data.actions?.length > 0 ? (
                <div className="p-4 overflow-y-auto">
                  {data.actions.map((action, idx) => (
                    <div key={idx}>
                      <h1 className="text-lg font-bold text-black">
                        <span className="fa fa-check-circle mr-2 text-[red]"></span>
                        {action.action_title || t("riskDashboard.fallback.noActionTitle")}
                      </h1>
                      <p className="text-normal">{action.action_details || t("riskDashboard.fallback.noActionDetails")}</p>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500 p-4">{t("riskDashboard.empty.noActions")}</p>
              ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedTabCard;